module.exports = __webpack_public_path__ + "static/img/rtc-caption.9e6cc18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/rtc-caption.png
// module id = uxeS
// module chunks = 1